import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Drafts from '@/components/Drafts'
import Documents from '@/components/Documents'
import About from '@/components/About'
import Help from '@/components/Help'
import Settings from '@/components/Settings'
import WaysToHelp from '@/components/WaysToHelp'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import Contact from '@/components/Contact'
import Account from '@/components/Account'
import Subscription from '@/components/Subscription'
import DraftSearch from '@/components/DraftSearch'
import DraftThreadingSearch from '@/components/DraftThreadingSearch'
import DraftDetail from '@/components/DraftDetail'
import DraftUpload from '@/components/DraftUpload'
import DraftColor from '@/components/DraftColor'
import DocumentSearch from '@/components/DocumentSearch'
import DocumentDetail from '@/components/DocumentDetail'
import Acknowledgements from '@/components/Acknowledgements'
import WeavingSoftware from '@/components/WeavingSoftware'
import DigitalDownloads from '@/components/DigitalDownloads'
import TreadleReducer from '@/components/TreadleReducer'
import TagCloud from '@/components/TagCloud'
import MyBoards from '@/components/MyBoards'
import BoardSearch from '@/components/BoardSearch'
import Updates from '@/components/Updates'
import DraftEditor from '@/components/DraftEditor'
import DraftEditorInstructions from '@/components/DraftEditorInstructions'
import DraftEditorIntroduction from '@/components/DraftEditorIntroduction'
import WeaveAlongPromo from '@/components/WeaveAlongPromo'
// import HandwovenPromo from '@/components/HandwovenPromo'
import WarpWeavePromo from '@/components/WarpWeavePromo'
import MYCSPromo from '@/components/MYCSPromo'
import DraftViewTest from '@/components/DraftViewTest'
import Profile from '@/components/Profile'
import store from '../store/index.js'

Vue.use(Router)

let routerInstance = new Router({
    routes: [
        {
            path: '/',
            component: Home,
            name: 'Home'
        },
        {
            path: '/login',
            component: Login,
            name: 'Login'
        },
        {
            path: '/drafts',
            component: Drafts,
            name: 'Drafts'
        },
        {
            path: '/documents',
            component: Documents,
            name: 'Docs'
        },
        {
            path: '/about',
            component: About,
            name: 'About'
        },
        {
            path: '/help',
            component: Help,
            name: 'Help'
        },
        {
            path: '/settings',
            component: Settings,
            name: 'Settings'
        },
        {
            path: '/ways-to-help',
            component: WaysToHelp,
            name: 'WaysToHelp'
        },
        {
            path: '/privacy-policy',
            component: PrivacyPolicy,
            name: 'PrivacyPolicy'
        },
        {
            path: '/contact',
            component: Contact,
            name: 'Contact'
        },
        {
            path: '/account',
            component: Account,
            name: 'Account'
        },
        {
            path: '/subscription',
            component: Subscription,
            name: 'Subscription'
        },
        {
            path: '/draft-detail/:id/:title?',
            component: DraftDetail,
            name: 'DraftDetail'
        },
        {
            path: '/draft-contribute',
            component: DraftUpload,
            name: 'DraftUpload'
        },
        {
            path: '/draft-color',
            component: DraftColor,
            name: 'DraftColor'
        },
        {
            path: '/collection-drafts/:searchType/:bookOrCategoryId?/:collectionTitle?',
            component: DraftSearch,
            name: 'DraftSearch'
        },
        {
            path: '/draft-threading-search',
            component: DraftThreadingSearch,
            name: 'DraftThreadingSearch'
        },
        {
            path: '/document-search/:searchType/:id?/:name?',
            component: DocumentSearch,
            name: 'DocumentSearch'
        },
        {
            path: '/document-detail/:id/:title?',
            component: DocumentDetail,
            name: 'DocumentDetail'
        },
        {
            path: '/acknowledgements',
            component: Acknowledgements,
            name: 'Acknowledgements'
        },
        {
            path: '/weaving-software',
            component: WeavingSoftware,
            name: 'WeavingSoftware'
        },
        {
            path: '/digital-downloads',
            component: DigitalDownloads,
            name: 'DigitalDownloads'
        },
        {
            path: '/treadle-reducer',
            component: TreadleReducer,
            name: 'TreadleReducer'
        },
        {
            path: '/tag-cloud/:searchType',
            component: TagCloud,
            name: 'TagCloud'
        },
        {
            path: '/myboards',
            component: MyBoards,
            name: 'MyBoards'
        },
        {
            path: '/board-search',
            component: BoardSearch,
            name: 'BoardSearch'
        },
        {
            path: '/updates',
            component: Updates,
            name: 'Updates'
        },
        {
            path: '/draft-editor/:id?',
            component: DraftEditor,
            name: 'DraftEditor'
        },
        {
            path: '/draft-editor-instructions',
            component: DraftEditorInstructions,
            name: 'DraftEditorInstructions'
        },
        {
            path: '/draft-editor-introduction',
            component: DraftEditorIntroduction,
            name: 'DraftEditorIntroduction'
        },
        {
            path: '/weave-along-promo',
            component: WeaveAlongPromo,
            name: 'WeaveAlongPromo'
        },
        {
            path: '/handwoven-promo',
            component: Subscription,
            name: 'Subscription'
        },
        {
            path: '/warpweave-promo',
            component: WarpWeavePromo,
            name: 'WarpWeavePromo'
        },
        {
            path: '/mycs-promo',
            component: MYCSPromo,
            name: 'MYCSPromo'
        },
        {
            path: '/draft-view-test/:id',
            component: DraftViewTest,
            name: 'DraftViewTest'
        },
        {
            path: '/profile/:id/:title?',
            component: Profile,
            name: 'Profile'
        }

    ],
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            console.log('returning saved position: ' + JSON.stringify(savedPosition))

            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(savedPosition)
                }, 1000)
            })
        }
//        if (to.hash) {
//            console.log('returning to hash: ' + JSON.stringify(to.hash))
//            return { selector: to.hash }
//        }
        else {
            // console.log('returning top position')
            return { x: 0, y: 0 }
        }
    }
})

routerInstance.beforeEach((to, from, next) => {
    // console.log('in routerInstance.beforeEach, to: ' + JSON.stringify(to.name) + ', from: ' + JSON.stringify(from.name) + ', next: ' + JSON.stringify(next.name))
    store.commit('setPreviousRouteName', from.name)
    next()
})

export default routerInstance



// WEBPACK FOOTER //
// ./src/router/index.js